import React, { useRef, useState, useEffect } from 'react';

import AddThread from './AddThread';
import { useComment } from './CommentProvider';
import CommentListCtx from './CommentListCtx';
import ThreadCard from './ThreadCard';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const ThreadOffset = 6;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const CommentList = ({
  filter,
  showModuleInTag,
  showTag,
  module,
  component,
  showPlaceHolderWhenNoData = true,
  shouldShowAddComment = true,
  getInnerTooltipPopupContainer,
  switchInput,
  isPanelActive,
  sendIdentifier,
  targetChannelId = null,
  commentListType,
}) => {
  const { threadData = [], loading } = useComment();
  const listRef = useRef();
  const [activeInput, setActiveInput] = useState([]);
  const DefaultDisplayOffset = useRef(ThreadOffset);

  useEffect(() => {
    setActiveInput(-2);
    if (!targetChannelId) {
      scrollList({ toTop: true });
    }
  }, [switchInput, module, threadData]);

  const handleHeight = (initHeight = 0, current, type) => {
    let height = initHeight;
    if (!current) {
      return 0;
    }
    if (typeof type === 'string') {
      height = current ? current[type] : 0;
    } else if (Array.isArray(type)) {
      type.forEach((item) => (height += current[item]));
    }
    return height;
  };

  const normalScroll = (ref, type) => {
    const current = ref.current;
    const height = handleHeight(-230, current, type);
    listRef.current.scrollTo({
      top: height,
      behavior: 'smooth',
    });
  };

  const delayScroll = (ref, type) => {
    setTimeout(() => {
      normalScroll(ref, type);
    }, 100);
  };

  const scrollList = ({ ref, type, delay = true, toTop }) => {
    if (toTop) {
      listRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    delay ? delayScroll(ref, type) : normalScroll(ref, type);
  };

  let cards = threadData;

  if (filter) {
    cards = threadData.filter(filter);
  }

  const [displayOffset, setDisplayOffset] = useState(
    DefaultDisplayOffset.current,
  );

  useEffect(() => {
    if (targetChannelId && cards.length > 0) {
      const targetIndex = cards.findIndex((i) => i.channel === targetChannelId);
      if (targetIndex < 0) {
        return;
      }
      const nextDisplayOffset = Math.max(ThreadOffset, targetIndex + 1);
      setDisplayOffset(nextDisplayOffset);
      DefaultDisplayOffset.current = nextDisplayOffset;
    } else {
      DefaultDisplayOffset.current = ThreadOffset;
    }
  }, [targetChannelId, cards.length]);

  useEffect(() => {
    if (!isPanelActive) {
      setDisplayOffset(DefaultDisplayOffset.current);
      listRef.current.scrollTo({ top: 0 });
    }
  }, [isPanelActive]);

  const handleActiveInput = (index) => {
    setActiveInput([index]);
  };

  console.log('displayOffset: ', displayOffset, cards);
  return (
    <CommentListCtx.Provider
      value={{ scrollList, activeInput, handleActiveInput }}
    >
      <div
        className={`comment-list ${
          showPlaceHolderWhenNoData ? '' : 'in-section'
        }`}
        ref={listRef}
        onScroll={(event) => {
          if (
            event.target.scrollHeight - 100 <
            event.target.scrollTop + event.target.clientHeight
          ) {
            setDisplayOffset((origin) => origin + 10);
          }
        }}
      >
        <Spin
          indicator={antIcon}
          spinning={loading}
          className="comment-loading-wrapper"
        />
        {/* <Loading isLoading={loading} className="comment-loading" /> */}
        {cards.map((thread, i) => (
          <ThreadCard
            {...thread}
            idx={i}
            key={thread.id}
            showModuleInTag={showModuleInTag}
            showTag={showTag}
            getInnerTooltipPopupContainer={getInnerTooltipPopupContainer}
            sendIdentifier={sendIdentifier}
            commentListType={commentListType}
          />
        ))}
        <div
          className="no-comment-placeholder"
          style={{
            display:
              cards.length === 0 && showPlaceHolderWhenNoData ? 'flex' : 'none',
          }}
        >
          No Comments
        </div>
      </div>
      {shouldShowAddComment ? (
        <AddThread
          module={module}
          component={component}
          sendIdentifier={sendIdentifier}
        />
      ) : (
        <div className="add-comment-placeholder" />
      )}
    </CommentListCtx.Provider>
  );
};

export default CommentList;
